import KformComponent from '../kform-component';
import { createComponentInstance } from '../kform-component-class';

const defaultTabs =[
	{ components: [], title: 'New tab', disabled: false },
];

export default class TabsComponent extends KformComponent {
	/**
	 * @param {import('@knitiv/api-client-javascript').ComponentTabs | undefined} settings
	 */
	constructor(settings = undefined) {
		super(settings);
		this.action = settings?.action ?? 'event';
		this.active = settings?.active ?? 0;
		this.event = settings?.event ?? null;
		this.input = false;
		this.tabs = settings?.tabs.map(tab => ({
			...tab,
			components: tab.components.map((/** @type {any} */ c) => createComponentInstance(c)),
		})) ?? defaultTabs
	}
}
